module.exports = __webpack_public_path__ + "static/media/place.4786748b.svg";